// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"291":"28931922","641":"dd48857e"}[chunkId] + ".js";
};